export const createParamsString = (params: any) => {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined)
    .map((key) => key + '=' + params[key].toString().trim())
    .join('&');
};
